<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-bind:to="{ 'name': $i18n.locale + 'Settings' }">
            {{ $t('settings') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-bind:to="{ name: $i18n.locale + 'ListPrices', params: { property: property.slug } }">
            {{ $t('prices') }}
          </router-link>
        </li>
        <li class="breadcrumb-item" v-if="$route.params.price" aria-current="page">
          {{ $t('price.edit') }}
        </li>
        <li class="breadcrumb-item active" aria-current="page" v-else>
          {{ $t('price.create') }}
        </li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            {{ $t('price.name') }}
          </h1>
          <p class="lead text-muted">
            <span v-if="$route.params.price">
              {{ $t('price.edit') }}
              {{$route.params.price}}
            </span>
            <span v-else>
              {{ $t('price.create') }}
            </span>
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <form id="priceForm">

                <h5>{{ $t('price.information') }}</h5>

                <div class="form-group">
                  <label for="property._id">{{ $t('property') }}</label>
                  <ValidationProvider name="property" vid="property._id" rules="required" v-slot="{ errors }">
                    <select class="form-control" v-model="property._id" :class="{ 'is-invalid': errors[0] }" disabled="true">
                      <option value="" disabled></option>
                      <option v-for="p in properties" v-bind:value="p._id">{{p.name}}</option>
                    </select>
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label for="price.room._id">{{ $t('room') }}</label>
                  <ValidationProvider name="room" vid="room" rules="required" v-slot="{ errors }">
                    <select class="form-control" v-model="price.room._id" :class="{ 'is-invalid': errors[0] }">
                      <option v-for="room in property.rooms" v-bind:value="room._id">{{room.name}}</option>
                    </select>
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label for="price.title">{{ $t('title') }}</label>
                  <ValidationProvider name="title" vid="price.title" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="price.title" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label for="valid.from">{{ $t('valid.from') }}</label>
                  <ValidationProvider name="valid from" vid="valid.from" rules="required" v-slot="{ errors }">
                    <date-picker :input-props='{
                                   class: "form-control " + (errors[0] ? "is-invalid" : ""),
                                 }'
                                 :firstDayOfWeek="2"
                                 v-model="valid.from"
                                 :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }"
                                 >
                    </date-picker>
                    <!--<input class="form-control" v-model="price.valid.from" :class="{ 'is-invalid': errors[0] }">-->
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <label for="valid.until">{{ $t('valid.until') }}</label>
                  <ValidationProvider name="valid until" vid="valid.until" rules="required" v-slot="{ errors }">
                    <date-picker :input-props='{
                                   class: "form-control " + (errors[0] ? "is-invalid" : ""),
                                 }'
                                 :firstDayOfWeek="2"
                                 v-model="valid.until"
                                 :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }"
                                 >
                    </date-picker>
                    <!--<input class="form-control" v-model="price.valid.until" :class="{ 'is-invalid': errors[0] }">-->
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label for="price.price">{{ $t('price.name') }}</label>
                  <ValidationProvider name="price" vid="price" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="price.price" :class="{ 'is-invalid': errors[0] }" type="number" step=".01" min="0">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <!-- Vat field -->
                <div class="form-group">
                  <label for="vat">{{ $t('price.vat') }}</label>
                  <ValidationProvider name="vat" vid="price.vat" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="price.vat" :class="{ 'is-invalid': errors[0] }" type="number" step=".1" min="0">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <!-- Breakfast field -->
                <div class="form-group">
                  <label for="breakfast">{{ $t('breakfast') }}</label>
                  <ValidationProvider name="breakfast" vid="price.breakfast" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="price.breakfast" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="d-flex w-100">

                  <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
                    <button v-b-modal.confirmDeleteModal  type="button" name="cancel" class="btn btn-danger flex-grow-1" v-bind:class="{'disabled': !price._id}">
                      {{ $t('price.delete') }}
                    </button>
                    <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)">
                      {{ $t('price.save') }}
                    </button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>

    <ConfirmDelete ref="confirmDelete" v-bind.sync="{type: 'price', delete: deletePrice}"></ConfirmDelete>

  </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import moment from 'moment';
const timestamp = Date.now();

import ConfirmDelete from '../partials/modals/ConfirmDelete.vue';

export default {
  name: 'CreatePrice',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name){
        vm.from = from.fullPath
      }else{
        vm.from = null
      }
    });
  },
  components: {
    DatePicker, ConfirmDelete
  },
  data: () => ({
    from: null,
    api: {
      url: '/prices',
      method: 'post'
    },
    property: {
      rooms: []
    },
    properties: [],
    price: {
      valid: {
        from: "",
        until: ""
      },
      room: {},
    },
    valid: {
      from: "",
      until: ""
    }
  }),
  watch: {
    'valid.from': function(val, oldVal) {
      console.log("check In")
      this.price.valid.from = moment(val).format('YYYY-MM-DD')
    },
    'valid.until': function(val, oldVal) {
      this.price.valid.until = moment(val).format('YYYY-MM-DD')
    }
  },
  created(){
    this.properties = this.$store.state.host.properties;
    if(this.$route.params.price){
      this.api.url = '/prices/' + this.$route.params.price;
      this.api.method = 'put'
      fetch(process.env.VUE_APP_API + this.api.url, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        this.price = {
          _id: response._id,
          room: {
            _id: response.room._id
          },
          title: response.title,
          valid: {
            from: response.valid.from,
            until: response.valid.until
          },
          breakfast: response.breakfast,
          price: response.price,
          vat: response.vat
        }
        this.valid.from = moment(response.valid.from).toDate();
        this.valid.until = moment(response.valid.until).toDate();

        this.property = this.$store.state.host.properties.find(p => p.rooms.find(r => r._id == this.price.room._id));
      })
    }else{
      this.property = this.$store.state.host.properties.find(p => p.slug == this.$route.params.property);
    }
  },
  methods: {
    submit: function(){
      console.log(this.price);
      return fetch( process.env.VUE_APP_API + this.api.url, {
        method : this.api.method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify(this.price)
      })
      .then(response => response.json())
      .then(response => {
        console.log(response);
        if(!response.error){
          if(this.from){
            this.$router.push(this.from);
          }else{
            this.$router.push('/' + this.$i18n.locale + '/' + this.property.slug + '/' + this.$t('prices.url'));
          }
        }else{
          console.log(response.error);
          this.$refs.form.setErrors(response.error.messages);
        }
      });
    },
    deletePrice: function(){
      //if(!confirm("Are you sure you want to delete price?")) return;
      return fetch(process.env.VUE_APP_API + '/prices/' + this.$route.params.price, {
        method: 'delete',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          this.$parent.messages.push({
            type: "alert",
            status: 'success',
            message: 'Price Deleted Successfully',
            time: timestamp
          })
          this.$router.push(this.from);
        }else{
          this.$parent.messages.push({
            type: "alert",
            status: 'danger',
            message: response.error,
            time: timestamp
          })
        }
      })
    }
  },
}
</script>


<i18n>
{
  "en": {
    "settings": "Settings",
    "prices": "Prices",
    "property": "Property",
    "price": {
      "name": "Price",
      "edit": "Edit Price",
      "create": "Create Price",
      "save": "Save Price",
      "delete": "Delete Price",
      "information": "Price information",
      "vat": "VAT"
    },
    "room": "Room Type",
    "title": "Service Title",
    "valid": {
      "from": "Valid From",
      "until": "Valid Until"
    },
    "breakfast": "Breakfast info"
  },
  "sl": {
    "settings": "Nastavitve",
    "prices": "Cene",
    "property": "Nastanitev",
    "price": {
      "name": "Cena",
      "edit": "Uredi ceno",
      "create": "Ustvari ceno",
      "save": "Shrani ceno",
      "delete": "Pobriši ceno",
      "information": "Podatki cene",
      "vat": "Stopnja DDV"
    },
    "room": "Tip sobe",
    "title": "Naziv storitve",
    "valid": {
      "from": "Veljavno od",
      "until": "Veljavno do"
    },
    "breakfast": "Informacije glede zajtrka"
  }
}
</i18n>
